import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  limit: 5,
  type: "",
  searchString: "",
  page: 1,
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setType: (state, action) => {
      state.type = action.payload;
    },
    setSearchString: (state, action) => {
      state.searchString = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    resetFilter: (state) => {
      state.limit = 5;
      state.type = "";
      state.searchString = "";
      state.page = 1;
    },
  },
});

export default filterSlice.reducer;
export const { resetFilter, setLimit, setPage, setSearchString, setType } = filterSlice.actions;
